import React, {useState, createContext, useContext, useCallback} from 'react';
import {signIn as sendSignInRequest} from '../api/auth';
import { getMainAddress } from '../api/address'
import { useHistory} from 'react-router-dom';
import session from '../sessions';

function AuthProvider(props) {
    const [user, setUser] = useState();
    const [loading, setLoading] = useState(true);
    const history = useHistory();

    const signIn = useCallback(async(email, password) => {
        var res = null
        await sendSignInRequest({email, password}).then(async(result) => {
            if (result.status === 200) {
                session.setSession("user",result.data,3600000); //1 hour
                setUser(result.data);
                if(result.data.roles[0] === 'ROLE_ADMIN') {
                    history.push('/admin/shipments/shipped-recents');
                } else {
                    history.push('/dashboard/overview');
                }
            } else {
                setLoading(false);
                setUser();
            }
            res = result;
        });
        return res;
    }, []);

    const signOut = useCallback(async() => {
        localStorage.removeItem("user");
        setUser();
        history.push("/logout")
    }, []);

    return (<AuthContext.Provider
        value={{
        user,
        signIn,
        signOut,
        loading
    }}
        {...props}/>);
}

const AuthContext = createContext({});
const useAuth = () => useContext(AuthContext);

export {AuthProvider, useAuth}
